<div class="help-card-container" ngbDropdown #helpDrop="ngbDropdown">
  <div class="help-card" id="helpCard" ngbDropdownToggle role="link">
    <a href="javascript:void(0)">
      <img src="assets/images/logos/help-icon.svg" alt="Help Icon">
    </a>
  </div>
  <div ngbDropdownMenu aria-labelledby="helpCard" role="menu">
    <div class="dd-menu-header">Help</div>
    <div class="dd-menu-separator"></div>
    <button class="dd-menu-item" ngbDropdownItem role="menuitem">FAQ</button>
    <button class="dd-menu-item" ngbDropdownItem role="menuitem">Contact Support</button>
    
  </div>
</div> 
